// extracted by mini-css-extract-plugin
export var button = "footer-dr-module--button--62921";
export var copyright = "footer-dr-module--copyright--e18dc";
export var desktop = "footer-dr-module--desktop--ac4f8";
export var inner = "footer-dr-module--inner--4ba59";
export var mobile = "footer-dr-module--mobile--b2c4c";
export var nav = "footer-dr-module--nav--9c911";